// eslint-disable-next-line no-restricted-imports
import { useDirectoryGetProductionCalendarQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useDirectoryGetProductionCalendar = () => {
  const {
    data,
    loading,
    error: apolloError,
  } = useDirectoryGetProductionCalendarQuery();

  const error = useError(apolloError);

  return {
    loading,
    error,
    productionCalendar: data?.productionCalendar,
  };
};
